<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Souscriptions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        Filtre
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <div class="col-sm-3">
                                <select @change="changeProduct()" v-model="query.product" class="form-control">
                                    <option value="">Tous les produits</option>
                                    <option value="1">Assurance Auto</option>
                                    <option value="3">Assurance Voyage</option>
                                    <option value="2">Assurance Habitation</option>
                                </select>
                            </div>
                            <div v-if="step === 1" class="col-sm-3">
                                <select @change="changeStatus()" v-model="query.namespace" class="form-control">
                                    <option value="all">Toutes</option>
                                    <option value="paid">Payées</option>
                                    <option value="negotiated">Négociées</option>
                                    <option value="in_negotiated">En négociation</option>
                                    <option value="add">Paiement à la livraison</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <section id="basic-tabs-components">
            <div class="row match-height">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item">
                                    <a @click="changeStep(1)" class="nav-link active" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Toutes</a>
                                </li>
                                <li class="nav-item">
                                    <a @click="changeStep(2)" class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Souscriptions sauvegardées</a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="home" aria-labelledby="home-tab" role="tabpanel">
                                    <!-- <all-subscription ref="all" :content="subscriptions"/> -->
                                    <all-subscription ref="all" />
                                </div>
                                <div class="tab-pane" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                                    <!-- <save-subscription ref="save" :content="saveSubscriptions" /> -->
                                    <save-subscription ref="save" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    </div>
</template>

<script>
    import AllSubscription from "./item/allSubscription";
    import SaveSubscription from "./item/saveSubscription";
    export default {
        name: "list",
        components: {SaveSubscription, AllSubscription},
        //props:['all','save'],
        data: () => ({
            subscriptions: {},
            saveSubscriptions: {},
            step: 1,
            query:{
                namespace: 'all',
                per: 10,
                page: 1,
                product: ''
            }
        }),
        created() {
            //this.subscriptions = JSON.parse(this.all);
            //this.saveSubscriptions = JSON.parse(this.save);
            //console.log("am called from subscription.list")
        },
        methods:{
            changeProduct(){
                if (this.step === 1){
                    this.$refs.all.makeFilter(this.query);
                }else{
                    this.$refs.save.makeFilter(this.query);
                }
            },
            changeStatus(){
                if (this.step === 1){
                    this.$refs.all.makeFilter(this.query);
                }else{
                    this.$refs.save.makeFilter(this.query);
                }
            },
            changeStep(val){
                if (val === 2){
                    this.query.product = '';
                    this.query.namespace = 'save';
                    this.step = val;
                }else {
                    this.query.product = '';
                    this.query.namespace = 'all';
                    this.step = val;
                }
            }
        }
    }
</script>

<style scoped>

</style>
